import { render, staticRenderFns } from "./DaoruNumber.vue?vue&type=template&id=523475dc&scoped=true&"
import script from "./DaoruNumber.vue?vue&type=script&lang=js&"
export * from "./DaoruNumber.vue?vue&type=script&lang=js&"
import style0 from "./DaoruNumber.vue?vue&type=style&index=0&id=523475dc&prod&lang=less&scoped=true&"
import style1 from "@/assets/css/index.css?vue&type=style&index=1&id=523475dc&prod&scoped=true&lang=css&"
import style2 from "@/assets/css/comparison.less?vue&type=style&index=2&id=523475dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523475dc",
  null
  
)

export default component.exports